export default function ($http) {
    return function (vehicleId, keeperId, model) {
        return $http.put(`api/vehicles/${ vehicleId }/keepers/${ keeperId }`, model);
    };
}



// WEBPACK FOOTER //
// ./Client/app/tasks/services/keepers/updateKeeperDetails.js